import React, { Component } from 'react';
import $ from 'jquery';
import { s3StaticPath, getDemoVideoLink } from '../../helper/helperFunctions';
import { MdPhotoSizeSelectActual, MdLocalMovies } from 'react-icons/md';
import { IoMdPlay } from 'react-icons/io';
import { FaHandHoldingHeart, FaQuestion } from 'react-icons/fa';
import { login, logout } from 'redux/actions/front-end-action';
import { connect } from 'react-redux';
import { SC } from '../../helper/ServerCall'
import { pathSegment } from '../../helper/queryString';



import VideoIcon from './VideoIcon'
class Demovideo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isHovered: false,
            full_name: '',
            phone: '',
            email: '',
            password: '',
            message: '',
            company: '',
            activeTabNo: 1,
            activeVideo: 1,
            bucket: 'https://grouptravelvideos.s3.amazonaws.com/',
            videoUrl: 'global/2025_Washington_DC_demo.mp4',
            location: 'Washington DC',
            showVideos: {
                dc: "true",
                orlando: "true",
                nyc: "true",
                chicago: "true"
            },
            agency: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleHover = this.handleHover.bind(this);
        this.activeTabFunction = this.activeTabFunction.bind(this);
        if (Object.keys(this.props.match.params).length > 1) {
            const params = { ...this.props.match.params };
            if (params.username !== undefined && params.password !== undefined) {
                this.props.loginCall(params.username, params.password)
            }
        }
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();
        // document.querySelector('.loginIcon').classList.add('open');
        this.setState({ submitted: true });
        const { email, password } = this.state;
        if (email && password) {
            this.props.loginCall(email, password);
        }
    }


    componentDidMount() {
        let params = Object.fromEntries(new URLSearchParams(this.props.location.search));
        let vals = Object.values(params);

        if (vals && vals[0] && vals[0].length) {
            this.setState({
                ...this.state,
                showVideos: params
            })
        }

        if (params && params.customerID) {
            SC.getCall(`getCustomizedDemoPlayerLogo/${pathSegment(params.customerID)}`).then(response => {
                if (response && response.data) {
                    this.setState({
                        ...this.state,
                        agency: response
                    })
                }
            })
        }
    }

    activeTabFunction(tab, name, url = null, location = null) {
        if (name === 'activeVideo') {
            if (this.state.activeVideo !== tab) {
                this.setState({ [name]: tab, videoUrl: url, location: location },);
            }
        } else {
            if (this.state.activeTabNo !== tab) {
                this.setState({ [name]: tab });
            }
        }
        return null;
    }

    handleVideo() {
        let demoVideo = document.getElementById("demoVideo");
        demoVideo.play();
    }

    inputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleHover() {
        // this.setState(prevState => ({
        //     isHovered: !prevState.isHovered
        // }));

        $("#clients div.client").hover(function () {
            $("#clients div.client").removeClass("pink_gradient")
            $(this).addClass("pink_gradient")
        }, function () {
            $("#clients div.client").removeClass("pink_gradient")
        })
    }
    render() {

        const videos = getDemoVideoLink(this.props.location.search);
        const { loggingIn } = this.props;
        // console.log("agency", this.state.agency);

        // const hoverClass = this.state.isHovered ? "client pink_gradient" : "client";
        // let sliderSettings = {
        //   dots: true,
        //   autoplay: true,
        //   infinite: true,
        //   speed: 500,
        //   slidesToShow: 1,
        //   slidesToScroll: 1,
        //   accessibility: false,
        //   className: 'benefits',
        //   prevArrow: <div><MdArrowBack /></div>,
        //   nextArrow: <div><MdArrowForward /></div>,
        // };
        const posters = {
            'Washington DC': 'washington-dc.jpg',
            'Chicago': 'Chicago.jpg',
            'New York City': 'New-York-City.jpg',
            'Orlando': 'Orlando.jpg',
            'Italy': 'Italy.jpg',
            'Memphis': 'Memphis.jpg',
            'Nashville': 'Nashville.jpg',
            'Nashville & Memphis': 'Nashville-Memphis.jpg',
            'St. Louis': 'St-Louis.jpg',
            'Performance Groups': 'Performance-Groups.jpg',
            'Tropical Adventures': 'Tropical-Adventures.jpg',
            'Mackinac Island': 'Mackinac-Island.jpg',
            'Ireland': 'Ireland.jpg',
            'Europe': 'Europe.jpg',
            'Alaska': 'Alaska.jpg',
            'New Orleans': 'New-Orleans.jpg',
        }
        const { email, password, submitted } = this.state

        return (
            <React.Fragment>
                <section id="uploaderTabs" className="section sampleVideos resetPadding">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12" style={{ padding: '0' }}>
                                <div className="tabsContainer">
                                    <div className="tabsHeader">
                                        <div className="grid">
                                            <div>
                                                <a href="#/" type='button'
                                                    onClick={() => this.activeTabFunction(1, 'activeTabNo')}

                                                    className={"tabBtn text_16 " + (this.state.activeTabNo === 1 ? "activeTab red_gradient" : "medium_blue_gradient")}><MdLocalMovies />&nbsp;Sample Videos</a>
                                            </div>
                                            <div>
                                                <a href="#/" type='button'
                                                    onClick={() => this.activeTabFunction(2, 'activeTabNo')}
                                                    className={"tabBtn text_16 " + (this.state.activeTabNo === 2 ? "activeTab red_gradient" : "medium_blue_gradient")}><FaQuestion />&nbsp;How it works</a>
                                            </div>
                                            <div>
                                                <a href="#/" type='button'
                                                    onClick={() => this.activeTabFunction(3, 'activeTabNo')}
                                                    className={"tabBtn text_16 " + (this.state.activeTabNo === 3 ? "activeTab red_gradient" : "medium_blue_gradient")} ><FaHandHoldingHeart />&nbsp;Benefits</a>
                                            </div>
                                            <div>
                                                <a href="#/" type='button'
                                                    onClick={() => this.activeTabFunction(4, 'activeTabNo')}
                                                    className={"tabBtn text_16 " + (this.state.activeTabNo === 4 ? "activeTab red_gradient" : "medium_blue_gradient")}><IoMdPlay />&nbsp;App Demo</a>
                                            </div>
                                            {/* <div>
                        <a href="#/" type='button'
                          onClick={() => this.activeTabFunction(5, 'activeTabNo')}
                          className={"tabBtn text_16 " + (this.state.activeTabNo === 5 ? "activeTab red_gradient" : "medium_blue_gradient")}><MdPhotoSizeSelectActual />&nbsp;View Photos</a>
                      </div> */}
                                        </div>
                                    </div>

                                    <div className="tabsContent" style={{ minHeight: 'calc(100vh - 44px)' }}>
                                        <div className="mb-lg logos">
                                            <img src={s3StaticPath('img/gtv_logos/group-travel-videos-wide-small.jpg')} alt="Group Travel Videos Logo" />
                                            {
                                                this.state.agency &&
                                                <img src={this.state.agency.data.file_path} log={console.log(this.state.agency.data)} height="66" alt={this.state.agency.data.file_title} />
                                            }
                                        </div>
                                        {this.state.activeTabNo === 1 &&
                                            <div className="contentContainer">
                                                <div className="flexElem respFlex">
                                                    <div>
                                                        <div className="text_18 text-left">Click Below to View Sample Videos</div>

                                                        <ul className="sampleVideosList">
                                                            {
                                                                this.state.showVideos.dc == "true" &&
                                                                <li onClick={() => this.activeTabFunction(1, 'activeVideo', 'global/2025_Washington_DC_demo.mp4', 'Washington DC')}>
                                                                    <VideoIcon iconClass={this.state.activeVideo === 1 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 1 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                    <span> Washington DC</span>
                                                                </li>
                                                            }
                                                            {
                                                                this.state.showVideos.nyc == "true" &&
                                                                <li onClick={() => this.activeTabFunction(2, 'activeVideo', 'global/2025_New_York_demo.mp4', 'New York City')}>
                                                                    <VideoIcon iconClass={this.state.activeVideo === 2 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 2 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                    <span> New York City</span>
                                                                </li>
                                                            }
                                                            {
                                                                this.state.showVideos.orlando == "true" &&
                                                                <li onClick={() => this.activeTabFunction(3, 'activeVideo', 'global/2025_Orlando_demo.mp4', 'Orlando')}>
                                                                    <VideoIcon iconClass={this.state.activeVideo === 3 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 3 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                    <span> Orlando</span>
                                                                </li>
                                                            }
                                                            {
                                                                this.state.showVideos.chicago == "true" &&
                                                                <li onClick={() => this.activeTabFunction(4, 'activeVideo', 'global/2025_Chicago_demo.mp4', 'Chicago')}>
                                                                    <VideoIcon iconClass={this.state.activeVideo === 4 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 4 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                    <span> Chicago</span>
                                                                </li>
                                                            }
                                                            {/* {
                                    this.state.showVideos.memphis == "true" &&
                                    <li onClick={() => this.activeTabFunction(5, 'activeVideo', 'global/2025_Nashville_And_Memphis_demo.mp4', 'Memphis')}>
                                      <VideoIcon iconClass={this.state.activeVideo === 5 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 5 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                      <span> Memphis</span>
                                    </li>
                                } */}
                                                            {
                                                                this.state.showVideos.nashville_and_memphis == "true" &&
                                                                <li onClick={() => this.activeTabFunction(6, 'activeVideo', 'global/2025_Nashville_And_Memphis_demo.mp4', 'Nashville & Memphis')}>
                                                                    <VideoIcon iconClass={this.state.activeVideo === 6 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 6 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                    <span> Nashville & Memphis</span>
                                                                </li>
                                                            }
                                                            {
                                                                this.state.showVideos.st_louis == "true" &&
                                                                <li onClick={() => this.activeTabFunction(7, 'activeVideo', 'global/2025_St_Louis_demo.mp4', 'St. Louis')}>
                                                                    <VideoIcon iconClass={this.state.activeVideo === 7 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 7 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                    <span> St. Louis</span>
                                                                </li>
                                                            }
                                                            {
                                                                this.state.showVideos.new_orleans == "true" &&
                                                                <li onClick={() => this.activeTabFunction(8, 'activeVideo', 'global/2025_New_Orleans_demo.mp4', 'New Orleans')}>
                                                                    <VideoIcon iconClass={this.state.activeVideo === 8 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 8 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                    <span> New Orleans</span>
                                                                </li>
                                                            }
                                                            {
                                                                this.state.showVideos.performance_groups == "true" &&
                                                                <li onClick={() => this.activeTabFunction(9, 'activeVideo', 'global/2025_Performance_Groups_demo.mp4', 'Performance Groups')}>
                                                                    <VideoIcon iconClass={this.state.activeVideo === 9 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 9 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                    <span> Performance Groups </span>
                                                                </li>
                                                            }
                                                        </ul>
                                                        <div className="text_18 mt-xlg text-left">Adult Senior Travel</div>

                                                        <ul className="sampleVideosList">
                                                            <li onClick={() => this.activeTabFunction(10, 'activeVideo', 'global/2025_senior_italy_demo.mp4', 'Italy')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 10 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 10 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Italy</span>
                                                            </li>
                                                            <li onClick={() => this.activeTabFunction(11, 'activeVideo', 'global/2025_senior_Alaska_demo.mp4', 'Alaska')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 11 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 11 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Alaska</span>
                                                            </li>
                                                            <li onClick={() => this.activeTabFunction(12, 'activeVideo', 'global/2025_senior_Ireland_demo.mp4', 'Ireland')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 12 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 12 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Ireland</span>
                                                            </li>
                                                            <li onClick={() => this.activeTabFunction(13, 'activeVideo', 'global/2025_senior_Europe_demo.mp4', 'Europe')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 13 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 13 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Europe</span>
                                                            </li>
                                                            <li onClick={() => this.activeTabFunction(14, 'activeVideo', 'global/2025_senior_Mackinac_Island_demo.mp4', 'Mackinac Island')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 14 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 14 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Mackinac Island</span>
                                                            </li>
                                                            <li onClick={() => this.activeTabFunction(15, 'activeVideo', 'global/2025_senior_Tropical_Adventures_demo.mp4', 'Tropical Adventures')}>
                                                                <VideoIcon iconClass={this.state.activeVideo === 15 ? "fa-spin" : ""} svgColor={this.state.activeVideo === 15 ? "url('#video-gradient')" : "currentColor"} svgID="video-gradient" />
                                                                <span> Tropical Adventures</span>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div id="video" style={{ border: "none" }}>
                                                        <div className="vidContainer">
                                                            <div className="section_heading mt-none text-center">{this.state.location}</div>

                                                            <div className="video_placeholder mb-none">
                                                                <video onPlay={() => { $(".video_placeholder .video_play").hide() }} onPause={() => { $(".video_placeholder .video_play").show() }} id="demoVideo" controls src={this.state.bucket + this.state.videoUrl} type="video/mp4" poster={this.state.bucket + `static/img/${posters[this.state.location]}`}></video>
                                                                <div className="video_play blue_gradient hover_dark" onClick={this.handleVideo}></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {this.state.activeTabNo === 2 &&
                                            <div className="contentContainer">
                                                <div className="flexElem">
                                                    <div>
                                                        <span className="howItWorksNumber purple_gradient">1</span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            We provide your group with a Unique username & password login to access the app and website—making it easy to upload trip photos, stay connected, and enjoy all the app’s features.
                                                        </div>
                                                        <div className="text_14 mt-xs">
                                                            {/* We can also send you a camera or memory card. */}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_gradient">2</span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            Everyone in your group can snap and share their favorite moments into one private gallery—bringing everyone’s memories together in one secure place.
                                                        </div>
                                                        <div className="text_14 mt-xs">
                                                            {/* You return any of our cameras or cards back in the prepaid mailer we provide. */}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_gradient">3</span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            We give your group’s shared memories the VIP treatment— removing duplicates or unwanted shots, then enhancing them with music, transitions, and effects. Once polished, your memories are reposted to your group's private gallery and transformed into a meaningful keepsake video.
                                                        </div>
                                                        {/* <div className="text_14 mt-xs">
                              Your photos can only be accessed with your group’s login.
                                    </div> */}
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_gradient">4</span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            {/* We ship your DVDs to you and make your video available to stream on our app &amp; website. */}
                                                            Your final keepsake video is available to stream in the app and download via our website. Easily share it across social platforms or with family and friends. Plus, it serves as an impactful recruiting tool for showcasing the value of your future trips.

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {this.state.activeTabNo === 3 &&
                                            <div className="contentContainer">
                                                <div className="flexElem">
                                                    <div>
                                                        <span className="howItWorksNumber purple_blue_gradient"></span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            Real-Time Communication:
                                                        </div>
                                                        <ul style={{ listStyle: 'unset' }}>
                                                            <li className="text_14 mt-sm">
                                                                Built-in Messaging feature <small>(No Phone Numbers Required)</small>
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Group Leaders can send announcements to entire group or create sub groups
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Document uploader <small>(examples: itineraries, emergency contacts, room assignments, etc.)</small>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_blue_gradient"></span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            Traveler Location &amp; Safety Features:
                                                        </div>
                                                        <ul style={{ listStyle: 'unset' }}>
                                                            <li className="text_14 mt-sm">
                                                                Assists Group leaders by helping keep track of travelers <br /> <small>(with permissions enabled. Only during travel dates.)</small>
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Establish meeting points with your group
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Helps ensure everyone stays together and safe throughout the trip
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_blue_gradient"></span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            Shared Private Gallery:
                                                        </div>
                                                        <ul style={{ listStyle: 'unset' }}>
                                                            <li className="text_14 mt-sm">
                                                                Upload your photos and approved video clips
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                View and enjoy moments shared by other group members
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                All trip memories are stored in one private, secure gallery just for your group
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_blue_gradient"></span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            Professional Storytelling Keepsake Video:
                                                        </div>
                                                        <ul style={{ listStyle: 'unset' }}>
                                                            <li className="text_14 mt-sm">
                                                                Our editors enhance your shared photos with music, transitions, and effects
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Duplicates and low-quality shots are removed for a clean final product
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                The final keepsake video is available to stream in the app and download from the website
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Include your Performance Music & Live Video Clips in your Keepsake Video for Free!
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_blue_gradient"></span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            Download &amp; Share with Ease:
                                                        </div>
                                                        <ul style={{ listStyle: 'unset' }}>
                                                            <li className="text_14 mt-sm">
                                                                Download your keepsake video to save and watch anytime, on any device
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Share memories on social media or send directly to loved ones
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Great for celebrating the trip or to use as a recruiting tool for future trip participation
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_blue_gradient"></span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            Share the Journey With Loved Ones at Home:
                                                        </div>
                                                        <ul style={{ listStyle: 'unset' }}>
                                                            <li className="text_14 mt-sm">
                                                                Parents and Family can log into the app to see real-time photo uploads
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Feel included in the experience as memories are made
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Brings peace of mind and excitement to loved ones at home
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div className="flexElem mt-xlg">
                                                    <div>
                                                        <span className="howItWorksNumber purple_blue_gradient"></span>
                                                    </div>
                                                    <div>
                                                        <div className="text_16 howItWorksPoints">
                                                            Boost Future Group Participation:
                                                        </div>
                                                        <ul style={{ listStyle: 'unset' }}>
                                                            <li className="text_14 mt-sm">
                                                                Use the Keepsake Video as a recruiting tool for future trips
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Inspire others by showcasing what makes your trips memorable
                                                            </li>
                                                            <li className="text_14 mt-sm">
                                                                Proven to help increase group sizes for future travel opportunities
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        <div className="row flexElem flexResponsive alignCenter justifyCenter">
                                            {this.state.activeTabNo === 4 &&
                                                videos.map((video, index) => (
                                                    <div
                                                        key={index}
                                                        className={
                                                            videos.length > 1
                                                                ? "col-md-6 mt-lg text-center"
                                                                : "col-md-12 mt-lg text-center"
                                                        }
                                                    >
                                                        <div className="contentContainer">

                                                            {video.title && (
                                                                <h4 className="mb-md font-weight-semibold text-xs-rem">{video.title} Demo</h4>
                                                            )}

                                                            <div className="video_placeholder mb-none">
                                                                <video
                                                                    id={`demoVideo_${index}`}
                                                                    controls
                                                                    src={video.src}
                                                                    poster={video.poster}
                                                                    onPlay={() => {
                                                                        $(".video_placeholder " + `.video_play_${index}`).hide();
                                                                    }}
                                                                    onPause={() => {
                                                                        $(".video_placeholder " + `.video_play_${index}`).show();
                                                                    }}
                                                                />

                                                                <div
                                                                    className={`video_play video_play_${index} blue_gradient hover_dark`}
                                                                    onClick={() => {
                                                                        document
                                                                            .getElementById(`demoVideo_${index}`)
                                                                            .play();
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>

                                        {/* {this.state.activeTabNo === 4 &&
                                            <div className="contentContainer">
                                                <div className="video_placeholder mb-none">
                                                    <video onPlay={() => { $(".video_placeholder .video_play").hide() }} onPause={() => { $(".video_placeholder .video_play").show() }} id="demoVideo" controls src={getDemoVideoLink(this.props.location.search)} type="video/mp4" poster={s3StaticPath('img/gtv_app_video.jpg')}></video>
                                                    <div className="video_play blue_gradient hover_dark" onClick={this.handleVideo}></div>
                                                </div>
                                            </div>
                                        } */}

                                        {/* {this.state.activeTabNo === 5 &&
                      <div className="contentContainer">
                        <div className="login_form">
                          <div className="text_16">Enter Your Group's Username and Password to view your photos on GroupTravelVideos.com:</div>
                          <form name="form">
                              <div className="form-group mt-md">
                                <input type="text" placeholder="Email or Username" onChange={this.handleChange} className={"form-control" + (submitted && !email ? ' has-error' : '')} name="email" value={email} />
                                {submitted && !email &&
                                <span style={{ marginTop: '0' }} className="help-block">Email is required.</span>
                                }
                              </div>
                              <div className="form-group">
                                <input type="password" onKeyUp={(e) => {
                                if (e.key === 'Enter') {
                                    this.button.click();
                                }
                                }}  placeholder="Password" onChange={this.handleChange} className={"form-control" + (submitted && !password ? ' has-error' : '')} name="password" value={password} />
                                {(submitted && !password) &&
                                    <span style={{ marginTop: '0' }} className="help-block">Password is required.</span>
                                }
                              </div>
                              <div className="form-group">
                                  <button style={{width:'100%'}} onClick={this.handleSubmit} className="btn btn-default btn_login">LOGIN</button>
                                  {
                                      loggingIn &&
                                      <img alt="imageLogin" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                  }
                              </div>
                          </form>
                      </div>
                      </div>
                    } */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

// export default Demovideo;

const mapDispatchToProps = (dispatch) => {
    return {
        loginCall: (email, password) => { dispatch(login(email, password)) },
        logoutCall: () => { dispatch(logout()) }
    }
}

function mapStateToProps(state) {
    const { loading, User, loggedIn } = state.frontEndUserReducer;
    return {
        loading, User, loggedIn
    };
}

const Samplevideo = connect(mapStateToProps, mapDispatchToProps)(Demovideo);
export default Samplevideo;
